export enum RNSStatus{
    Other = 1,
    Error = 2,
    NumberNotOnFile = 3,
    DeclarationAccepted = 4,
    GoodsReleased = 5,
    GoodsRequiredForExamination = 6
}


// WEBPACK FOOTER //
// ./app/objects/pars-status-widget/RNS-status.ts